import { BuyAgainLink } from "./BuyAgain/index.js";
import { CartSystemDefinedLink } from "./Cart/index.js";
import { CookieSettingsLink } from "./CookieSettings/index.js";
import { FeedbackLink } from "./Feedback/index.js";
import { FindAWarehouseLink } from "./FindAWarehouse/index.js";
import { LanguageSelector } from "./LanguageSelector/index.js";
import { MyAccountLink } from "./MyAccount/index.js";
import { OrdersAndReturnsLink } from "./OrdersAndReturns/index.js";
import { SameDay } from "./SameDay/index.js";
import { Selector } from "./Selector/index.js";
import { WarehouseHours } from "./WarehouseHours/index.js";
import { WishlistLink } from "./Wishlist/index.js";
const COMPONENT_MAP = {
  "buy-again": BuyAgainLink,
  cart: CartSystemDefinedLink,
  "cookie-settings": CookieSettingsLink,
  feedback: FeedbackLink,
  "instacart-same-day": SameDay,
  "language-selector": LanguageSelector,
  lists: WishlistLink,
  "location-selector": Selector,
  "my-account-sign-in": MyAccountLink,
  orders: OrdersAndReturnsLink,
  "warehouse-selector": FindAWarehouseLink,
  warehouses: FindAWarehouseLink,
  "warehouse-hours": WarehouseHours
};
const DEVELOPMENT_KEY_MAP = {
  "buy-again": "",
  cart: "",
  "cookie-settings": "",
  feedback: "",
  "instacart-same-day": "",
  "language-selector": "language_selector",
  lists: "",
  "location-selector": "country_selector",
  "my-account-sign-in": "",
  orders: "",
  "warehouse-selector": "",
  warehouses: "",
  "warehouse-hours": ""
};
const BUY_AGAIN_SYSTEM_LINK_ENTRY_ID = "blt9b4a1f5d78f9b6d3";
const CARD_SYSTEM_LINK_ENTRY_ID = "blt9bfac165c04ad3d8";
const COOKIE_SETTINGS_SYSTEM_LINK_ENTRY_ID = "bltd186e76358bd21cb";
const MY_ACCOUNT_SIGN_IN_SYSTEM_LINK_ENTRY_ID = "bltf42d37e33381c90b";
const FEEDBACK_SYSTEM_LINK_ENTRY_ID = "blt91c3b2ed3529da11";
const FIND_A_WAREHOUSE_SYSTEM_LINK_ENTRY_ID = "blt96d43618fa741cd4";
const LANGUAGE_SELECTOR_SYSTEM_LINK_ENTRY_ID = "blt253daa3851252178";
const LOCATION_SELECTOR_SYSTEM_LINK_ENTRY_ID = "bltd3b60dcc07d7f0a6";
const ORDERS_RETURNS_SYSTEM_LINK_ENTRY_ID = "blt0e679cbbcfcd1eaf";
const SAME_DAY_INSTACART_SYSTEM_LINK_ENTRY_ID = "blt5bf34b83a8dbb4de";
const WISHLIST_SYSTEM_LINK_ENTRY_ID = "bltbd5dc2dfa5dd4874";
export {
  BUY_AGAIN_SYSTEM_LINK_ENTRY_ID,
  CARD_SYSTEM_LINK_ENTRY_ID,
  COMPONENT_MAP,
  COOKIE_SETTINGS_SYSTEM_LINK_ENTRY_ID,
  DEVELOPMENT_KEY_MAP,
  FEEDBACK_SYSTEM_LINK_ENTRY_ID,
  FIND_A_WAREHOUSE_SYSTEM_LINK_ENTRY_ID,
  LANGUAGE_SELECTOR_SYSTEM_LINK_ENTRY_ID,
  LOCATION_SELECTOR_SYSTEM_LINK_ENTRY_ID,
  MY_ACCOUNT_SIGN_IN_SYSTEM_LINK_ENTRY_ID,
  ORDERS_RETURNS_SYSTEM_LINK_ENTRY_ID,
  SAME_DAY_INSTACART_SYSTEM_LINK_ENTRY_ID,
  WISHLIST_SYSTEM_LINK_ENTRY_ID
};
